import { render, staticRenderFns } from "./ConsensiProfiliListModalComponent.vue?vue&type=template&id=6e5d1c65&scoped=true"
import script from "./ConsensiProfiliListModalComponent.vue?vue&type=script&lang=js"
export * from "./ConsensiProfiliListModalComponent.vue?vue&type=script&lang=js"
import style0 from "./ConsensiProfiliListModalComponent.vue?vue&type=style&index=0&id=6e5d1c65&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5d1c65",
  null
  
)

export default component.exports